import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { SecondPageIndexBase } from 'vnpost-shared';
import { SaleRecordService } from '../services/sale-record.service';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SaleRecordAddComponent } from './sale-record-add/sale-record-add.component';
import { SaleRecordEditComponent } from './sale-record-edit/sale-record-edit.component';
import { ImportSaleRecordComponent } from './import-sale-record/import-sale-record.component';

@Component({
  selector: 'app-sale-record',
  templateUrl: './sale-record.component.html',
  styleUrls: ['./sale-record.component.css'],
})
export class SaleRecordComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: SaleRecordAddComponent;
  @ViewChild('pEdit', { static: false }) pEdit: SaleRecordEditComponent;
  // @ViewChild('pRestorePasswd', { static: false }) pRestorePasswd: SaleRecordResetpasswdComponent;
  @ViewChild('pImport') pImport: ImportSaleRecordComponent;

  unitCode = this.currentUser?.unitCode;
  listUnit: { label: string; value: string }[] = [];

  code: any;
  nameUser: any;
  phone: any;
  formGroup: any;

  constructor(
    protected _injector: Injector,
    protected _saleRecordService: SaleRecordService
  ) {
    super(_saleRecordService, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
  }

  ngOnInit() {
    this.loadTableColumnConfig();
    this.getData();
  }

  loadTableColumnConfig() {
    this.cols = [
      {
        field: 'contractCode',
        header: 'Mã hợp đồng',
        visible: true,
        sort: true,
      },
      {
        field: 'productName',
        header: 'Loại sản phầm',
        visible: true,
        sort: true,
      },
      { field: 'nameUser', header: 'Họ tên', visible: true, sort: true },
      { field: 'startDate', header: 'Ngày bắt đầu hợp đồng', visible: true },
      { field: 'endDate', header: 'Ngày kết thúc hợp đồng', visible: true },
      { field: 'phone', header: 'Số điện thoại', visible: true },
      { field: 'salesNumber', header: 'Doanh số bán', visible: true },
      { field: 'action', header: 'Hành động', visible: true },
    ];
  }

  async getData() {
    this.isLoading = true;
    var model = {
      contractCode: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize,
      nameUser: this.nameUser ?? '',
      phone: this.phone ?? '',
      unitCode: this.currentUser.unitCode
    };
    await this._saleRecordService.getAll(model).then(
      (response) => {
        this.dataSource = response.data;
        this.totalRecord = response.total;
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        this._notifierService.showHttpUnknowError();
      }
    );
  }

  editSaleRecord(item: any, isDisable: boolean) {
    if (item && item.code) {
      var model = {
        code: item.code,
        isDisable: isDisable,
      };
      this.pEdit.showPopup(model);
    }
  }

  add() {
    this.pCreate.showPopup();
  }

  deleteSaleRecord(item: any) {
    if (item && item.code) {
      this._notifierService
        .showDeleteConfirm('Bạn có chắc muốn xóa hồ sơ bán hàng này')
        .then((res) => {
          if (res) {
            this._saleRecordService.delete(item.code).then(
              () => {
                this._notifierService.showDeleteDataSuccess();
                this.getData();
              },
              () => {
                this._notifierService.showDeleteDataError();
              }
            );
          }
        });
    }
  }

  onImport() {
    this.pImport.showPopup();
  }
}
